module.exports = __webpack_public_path__ + "img/insurance_record.a74ab0f9.svg";